import { gql } from '@apollo/client';

import { SubjectFragment } from 'approot/shared/graphql/startup-data/startup-data.graphql';
import { lessonEnglishContentAreaFragment } from '../content-areas/content-areas.graphql';
import { unitPlannerFragment } from 'approot/unit/unit.graphql';

export const lessonUnitFragment = gql`
  fragment LessonUnitFragment on Lesson {
    unit {
      id
      name
      slug
      unitStatus
      subjects {
        ...SubjectFragment
      }
      topic {
        id
        label
        slug
      }
      lessons {
        id
        name
        slug
        sort
      }
      assessments {
        id
        name
        slug
        sort
      }
      ...UnitPlannerFragment
    }
  }
  ${unitPlannerFragment}
  ${SubjectFragment}
`;

export const lessonPlannerFragment = gql`
  fragment LessonPlannerFragment on Lesson {
    id
    inPlanner {
      term
      added
      unitId
    }
  }
`;

export const lessonIntegratedUnitFragment = gql`
  fragment LessonIntegratedUnitFragment on Lesson {
    integratedUnit {
      id
      name
      slug
      unitStatus
      subjects {
        ...SubjectFragment
      }
      topic {
        id
        label
        slug
      }
      lessons {
        id
        name
        slug
        integratedSort
      }
      assessments {
        id
        name
        slug
        integratedSort
      }
      ...UnitPlannerFragment
    }
  }
  ${unitPlannerFragment}
  ${SubjectFragment}
`;

export const lessonDetailsFragment = gql`
  fragment LessonDetailsFragment on Lesson {
    id
    name
    duration
    bookmarked
    authorId
    ...LessonUnitFragment
    ...LessonIntegratedUnitFragment
    ...LessonEnglishContentAreaFragment
    ...LessonPlannerFragment
    subjects {
      ...SubjectFragment
    }
    years {
      id
      name
      label
    }
  }
  ${lessonUnitFragment}
  ${lessonIntegratedUnitFragment}
  ${lessonEnglishContentAreaFragment}
  ${lessonPlannerFragment}
  ${SubjectFragment}
`;

export const UPDATE_LESSON_NAME = gql`
  mutation UpdateLessonName($input: UpdateLessonNameInput!) {
    updateLessonName(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_LESSON_DURATION = gql`
  mutation UpdateLessonDuration($input: UpdateLessonDurationInput!) {
    updateLessonDuration(input: $input) {
      id
      duration
    }
  }
`;

// Here we return the unit fragment which contains the collection
// of lesson/assessments we originally query on the unit fron lesson.tsx.
// There seems to be a bug when we dont include the lesson/assessments where
// the lesson.tsx does not re-render and lesson-details never receives the updated
// unit information and thus the UI is out of sync with the updates.
export const UPDATE_LESSON_UNIT = gql`
  mutation UpdateLessonUnit($input: UpdateLessonUnitInput!) {
    updateLessonUnit(input: $input) {
      id
      ...LessonUnitFragment
    }
  }
  ${lessonUnitFragment}
`;

export const UPDATE_LESSON_INTEGRATED_UNIT = gql`
  mutation UpdateLessonIntegratedUnit(
    $input: UpdateLessonIntegratedUnitInput!
  ) {
    updateLessonIntegratedUnit(input: $input) {
      id
      ...LessonIntegratedUnitFragment
    }
  }
  ${lessonIntegratedUnitFragment}
`;

export const REMOVE_LESSON_INTEGRATED_UNIT = gql`
  mutation RemoveLessonIntegratedUnit(
    $input: DeleteLessonIntegratedUnitInput!
  ) {
    deleteLessonIntegratedUnit(input: $input) {
      id
      ...LessonIntegratedUnitFragment
    }
  }
  ${lessonIntegratedUnitFragment}
`;

export const UPDATE_LESSON_SUBJECT = gql`
  mutation UpdateLessonSubjects($input: UpdateLessonSubjectsInput!) {
    updateLessonSubjects(input: $input) {
      id
      subjects {
        id
        name
        label
      }
      # clear outcomes & concepts
      outcomes {
        id
      }
      bigIdeas {
        id
      }
      textualConcepts {
        id
      }
    }
  }
`;

export const UPDATE_LESSON_YEARS = gql`
  mutation UpdateLessonYears($input: UpdateLessonYearsInput!) {
    updateLessonYears(input: $input) {
      id
      years {
        id
        name
        label
      }
      # clear outcomes
      outcomes {
        id
      }
    }
  }
`;
